import { render, staticRenderFns } from "./IconFilters.vue?vue&type=template&id=6dd771be"
import script from "./IconFilters.vue?vue&type=script&lang=js"
export * from "./IconFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports